import { useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";

export default function useGetInvestmentsGrouped(archived = false) {
  return useQuery({
    queryKey: ["investments/grouped", { archived }],
    queryFn: async () => {
      return axiosInstance
        .get("/investments/grouped", { params: archived ? { archived: true } : undefined })
        .then((res) => res.data);
    },
    retry: false,
    staleTime: 1000 * 30,
  });
}
